import { Button } from 'components/ui/Button';
import { useTranslation } from 'react-i18next';
import styles from './UserRestricted.module.scss';
import { logout } from 'store/thunks/auth/auth';
import { useAppDispatch } from 'store/hooks';
import { useNavigate } from 'react-router-dom';
import { useLimits } from 'hooks';
import { useEffect } from 'react';
import { AppRoutes } from 'config/routes';

export function UserRestricted() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const { hasOrganization, isLimitedUser, refetch } = useLimits();

  const handleConfirmLogout = () => {
    dispatch(logout());
    navigate('/');
  };

  useEffect(() => {
    if (hasOrganization) {
      navigate(AppRoutes.Dashboard.Home + AppRoutes.Dashboard.Contracts.Home);
    }
  }, [hasOrganization, navigate]);

  useEffect(() => {
    if (!isLimitedUser) {
      return undefined;
    }

    const id = window.setInterval(() => {
      refetch();
    }, 15000);

    return () => window.clearInterval(id);
  }, [isLimitedUser, refetch]);

  return (
    <div className={styles.root}>
      <div className={styles.content}>
        <div className={styles.firstBlock}>
          <div className={styles.header}>
            {t('Connects')} <br /> {t('Business')}
          </div>
          <div className={styles.subtitle}>
            {t(
              'Welcome to Contracteum, a platform for secure digital transactions under your full control',
            )}
          </div>
        </div>

        <div className={styles.secondBlock}>
          <span className={styles.title}>{t('Вы не связаны ни с одной организацией.')}</span>
          <span className={styles.restrictedText}>
            {t(
              'Чтобы продолжить использовать сервис "Контрактиум" вам надо быть сотрудником минимум одной организации',
            )}
          </span>

          <div className={styles.buttonContainer}>
            <Button
              
              className={styles.button}
              onClick={() => {
                refetch();
              }}
            >
              {t('Check again')}
            </Button>
            <Button variant="danger" className={styles.button} onClick={handleConfirmLogout}>
              {t('Выйти')}
            </Button>
          </div>
        </div>
      </div>

      <div className={styles.bottom}></div>
    </div>
  );
}
